import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Music2, Home, Headphones, ArrowRight, HelpCircle } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';
import SEO from './SEO';
import '../../styles/Home.css';
import '../../styles/Auth.css';

export default function NotFoundPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0f', color: '#fff', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="404 - Page Not Found | SenritsuX"
        description="The requested page could not be found on SenritsuX. Explore our verified Artist WEB, music services, or return to the homepage."
        noindex={true}
      />
      <Navbar />

      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4rem 1.5rem' }}>
        <div
          className="auth-card"
          style={{
            maxWidth: '560px',
            width: '100%',
            textAlign: 'center',
            padding: '3.5rem 2rem',
            borderRadius: '20px',
            border: '1px solid rgba(217, 251, 6, 0.25)',
            background: 'linear-gradient(145deg, rgba(77, 74, 182, 0.15) 0%, rgba(10, 10, 15, 0.9) 100%)',
          }}
        >
          <div
            style={{
              display: 'inline-flex',
              padding: '0.4rem 1.2rem',
              borderRadius: '20px',
              background: 'rgba(217, 251, 6, 0.15)',
              color: '#d9fb06',
              fontWeight: 800,
              fontSize: '1.1rem',
              marginBottom: '1rem',
              letterSpacing: '2px',
            }}
          >
            ERROR 404
          </div>

          <h1 style={{ fontSize: '2.4rem', fontWeight: 800, marginBottom: '0.8rem', color: '#fff' }}>
            Lost in the Mix?
          </h1>

          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1rem', lineHeight: 1.6, marginBottom: '2.5rem' }}>
            The track, artist profile, or page you were looking for doesn't exist or may have been moved. Let's get you back on frequency.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.8rem', marginBottom: '2rem' }}>
            <Link
              to="/"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                background: '#d9fb06',
                color: '#000',
                padding: '0.8rem',
                borderRadius: '10px',
                fontWeight: 700,
                textDecoration: 'none',
                fontSize: '0.92rem',
              }}
            >
              <Home size={16} /> Home
            </Link>

            <Link
              to="/artists"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.18)',
                color: '#fff',
                padding: '0.8rem',
                borderRadius: '10px',
                fontWeight: 600,
                textDecoration: 'none',
                fontSize: '0.92rem',
              }}
            >
              <Music2 size={16} color="#d9fb06" /> Artist WEB
            </Link>

            <Link
              to="/services"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.18)',
                color: '#fff',
                padding: '0.8rem',
                borderRadius: '10px',
                fontWeight: 600,
                textDecoration: 'none',
                fontSize: '0.92rem',
              }}
            >
              <Compass size={16} color="#d9fb06" /> Services &amp; Distribution
            </Link>

            <Link
              to="/faq"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.18)',
                color: '#fff',
                padding: '0.8rem',
                borderRadius: '10px',
                fontWeight: 600,
                textDecoration: 'none',
                fontSize: '0.92rem',
              }}
            >
              <HelpCircle size={16} color="#d9fb06" /> Help &amp; FAQs
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
